import type { StripeElementsOptionsMode } from '@stripe/stripe-js';

// Raw token values mirrored from @change/ds-tokens (see package.json for current version)
// so the Stripe iframe matches surrounding input field styling from createDivInputStyles.
// Stripe's Elements API does not accept CSS custom properties, so these must be literal values.
// Light mode only — dark mode is not handled by this experiment.
// If ds-tokens updates these values, update them here too.
const DEFAULT_STRIPE_APPEARANCE: NonNullable<StripeElementsOptionsMode['appearance']> = {
	theme: 'stripe',
	variables: {
		borderRadius: '8px',
		colorText: '#2d2f37',
		colorTextPlaceholder: 'rgba(58, 62, 73, 0.8)',
		fontSizeBase: '14px',
	},
	rules: {
		'.Input': {
			border: '1px solid #6f7381',
			boxShadow: 'none',
			padding: '10px 12px',
		},
		'.Input:focus': {
			border: '1px solid transparent',
			boxShadow: '0 0 0 2px #4771ff',
			outline: 'none',
		},
	},
};

export function getDefaultStripeAppearance(): NonNullable<StripeElementsOptionsMode['appearance']> {
	return DEFAULT_STRIPE_APPEARANCE;
}
